// extracted by mini-css-extract-plugin
module.exports = {"root":"TaskModalDisplayDeadline_root__1bwnS","divider":"TaskModalDisplayDeadline_divider__33yFb","deadline":"TaskModalDisplayDeadline_deadline__2lysv"};